import { render, staticRenderFns } from "./OwnReports.vue?vue&type=template&id=12d63273&scoped=true"
import script from "./OwnReports.vue?vue&type=script&lang=js"
export * from "./OwnReports.vue?vue&type=script&lang=js"
import "./OwnReports.vue?vue&type=style&index=0&id=12d63273&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d63273",
  null
  
)

export default component.exports